var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_160_38)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_160_38",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_160_38",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_160_38",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAgNJREFUeF7tmr8rRlEYxz+vRCS/JpLBKEmZJCkDmyx22SyYFP8AshpkMdgMDDYlUUoWGeQvYLD4sRiUH/fUfdVb3rd7zj0393S/dz7fp/N83+c8z+ee+5b4v6ceGAOmgCGgH2gH2oC6BNt6AToTrKu5pJQ2gIO+GVgGFoFuB31ZEqQB5hffB/pSJB6sATNRmR8AjR6SNyGCqoBh4BJo8pR8UAaYhnYTNzqP+YdTAdPAsc/M41jBHIGTeNT59iAIA8yZfwUafGcfShMcBy4ySD6YJjgP7BXZgBVgy8GAL2AHOALequg/gVuH2BWSrFF4NQKfDYdNLkSYvOugs5ZkbcBa1ADXLXf1FL8jfFvqnJbn0YA7YNApGweRDHAwzUbicgRUAToC6gFqgsFNgTOg9Y/u2AX02HRN4AN4SKB5BMy7RqrH1xh8BjpS7cRefAWM2ssqFSEbcAjMFtmAbWCpyAYYyNossgFz8TeGVB6E3AMmo09rp6myB0I2YAC4L6oB5q6gBXgvqgEGlHrTJm/0oR6B8+i2eSJPBlTbi8t9wDUw4iO5JDF8VYAMqOKAKsDhVlhHQD1ATVBTQGMwyQz3sUYc4MPFGjHEAeIA+8/jAiGBkEBIICQQyng8/4YXCGXstEBIICQQsv6jpEhQJCgSFAmKBDPmE5Fg2QGhcMalJhTOOwr/AFIbiEEUWDL5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSvg);
export default __webpack_public_path__ + "static/media/FacebookSVG.736f1cc6e4a876dd6b9cef392f5908d2.svg";
export { ForwardRef as ReactComponent };